import { useState } from 'react'
import useOnPremAgentClient from '~/api/OnPremAgentClient/useOnPremAgentClient'
import { DataIngestor } from '~/api/onPremAgent/dataIngestorsAPI'
import Button from '~/components/buttons/Button'
import { StructuredDataFormData } from '~/components/StructuredDataForm/StructuredDataForm'
import Toaster from '~/components/Toaster'
import DataIngestorConfigForm from '../DataIngestorConfigForm'
import cs from './configure_settings.scss'

export default function ConfigureSettings(props: { dataIngestor: DataIngestor }) {
  const client = useOnPremAgentClient()
  const { dataIngestor } = props
  const [configValues, setConfigValues] = useState<StructuredDataFormData>(
    dataIngestor.config || {},
  )
  const saveSettings = async () => {
    try {
      await client.dataIngestors.updateDataIngestorConfig(dataIngestor.uuid, {
        // This is required because the pydantic type on the request is dict.
        // TODO: Fix typing on the backend.
        config: configValues as Record<string, never>,
      })
      Toaster.show({
        message: `Successfully saved settings for ${dataIngestor.instrument_name}`,
        intent: 'success',
      })
    } catch (_e) {
      Toaster.show({
        message: `Failed to save settings for ${dataIngestor.instrument_name}.`,
        intent: 'danger',
      })
    }
  }

  return (
    <div className={cs.configureSettings}>
      <div className={cs.formContainer}>
        <DataIngestorConfigForm
          className={cs.configForm}
          instrumentType={dataIngestor.instrument_type}
          configValues={configValues}
          setConfigValues={setConfigValues}
        />
      </div>

      <div className={cs.footer}>
        <Button
          type='primary'
          label='Save Settings'
          onClick={saveSettings}
          className={cs.button}
        />
      </div>
    </div>
  )
}
